import { Domain } from 'library/ts/model/enums/web/Domain';

export class FreewheelConstants {
	private static _instance: FreewheelConstants = new FreewheelConstants();

	constructor() {
		if ( FreewheelConstants._instance ) {
			throw new Error(
				this.name +
				' is a Singleton and can only be accessed through ' +
				this.name +
				'.getInstance()'
			);
		}
		FreewheelConstants._instance = this;
	}

	get name(): string {
		return 'FreewheelConstants';
	}

	/**
	 * @description Returns scheme
	 * @return {string}
	 */
	get scheme(): string {
		return window.SmartTag.runtimeVO.app.ssl === true ? 'https' : 'http';
	}

	// IMPORTANT: all hardcoded values are specified in https://docs.google.com/spreadsheets/d/1trwgwrp52kR-7wc9WL1X9GM1zp8Y1oVHrqSiT49H6NI/edit#gid=2030777926

	/**
	 * @description Returns host for IMA ad call including customer ID prefix
	 * @return {string}
	 */
	get hostIMA(): string {
		// return '140cc.v.fwmrm.net/ad/g/1';	//test value
		return '7f077.v.fwmrm.net/ad/g/1'; // prod value
	}

	/**
	 * @description Returns Asset Network ID.
	 * @return {string}
	 */
	get assetNetworkId(): string {
		// return '82125';	//test value
		return '520311'; // prod value
	}

	/**
	 * @description Returns Site Section ID for Paramount+ LIVE
	 * @return {string}
	 */
	get siteSectionPPlusLive(): string {
		return 'streaming_paramountplus_ctv_chromecast_live'; // prod value
	}

	/**
	 * @description Returns Site Section ID for Paramount+ VOD
	 * @return {string}
	 */
	get siteSectionPPlusVOD(): string {
		return 'streaming_paramountplus_ctv_chromecast_vod'; // prod value
	}

	/**
	 * @description Returns Site Section ID for CBS LIVE
	 * @return {string}
	 */
	get siteSectionCBSLive(): string {
		return 'vcbs_cbs_ctv_chromecast_live'; // prod value
	}

	/**
	 * @description Returns Site Section ID for CBS VOD
	 * @return {string}
	 */
	get siteSectionCBSVOD(): string {
		return 'streaming_paramountplus_ctv_chromecast_vod'; // prod value
	}

	/**
	 * @description Returns Capabilities Flag.
	 * @return {string}
	 */
	get capabilitiesFlag(): string {
		return '+amcb+emcr+sltp+slcb+qtcb+vicb+fbad+sync+nucr+aeti';
	}

	/**
	 * @description Returns Default Capabilities
	 * @return {string}
	 */
	get defaultCapabilities(): string {
		return '1023';
	}

	/**
	 * @description Returns Network ID
	 * @return {string}
	 */
	get networkId(): string {
		// return '82125';	//test value
		return '520311'; // prod value
	}

	/**
	 * @description SLAU
	 * @return {string}
	 */
	get slau(): string {
		return '[SLAU]';
	}

	/**
	 * @description Returns Player Profile
	 * @return {string}
	 */
	get playerProfile(): string {
		// return '82125:GoogleDAICSAI_v01';	//test value
		return '520311:GoogleDAICSAI_v01'; // prod value
	}

	/**
	 * @description Returns Page View
	 * @return {string}
	 */
	get pageView(): string {
		return this.randomTag;
	}

	/**
	 * @description Returns Output / Response
	 * @return {string}
	 */
	get response(): string {
		return 'vmap1+vast4';
	}

	/**
	 * @description Returns Site Section Network ID
	 * @return {string}
	 */
	get siteSectionNetworkId(): string {
		// return '82125';	//test value
		return '520311'; // prod value
	}

	/**
	 * @description Returns Video Player
	 * @return {string}
	 */
	get videoPlayer(): string {
		return this.randomTag;
	}

	/**
	 * @description Returns Size
	 * @return {string}
	 */
	get size(): string {
		return '640x480';
	}

	/**
	 * @description Returns Description URL for CBS.com
	 * @return {string}
	 */
	get descUrlCBS(): string {
		return 'https://www.' + Domain.CBSCOM;
	}

	/**
	 * @description Returns Description URL for ParamountPlus.com
	 * @return {string}
	 */
	get descUrlPPlus(): string {
		return 'https://www.' + Domain.PPLUS;
	}

	/**
	 * @description Returns string literal "[RANDOM]". When passed as a query parameters in Freewheel ad calls, "[RANDOM]" gets replaced with a random number by AVIA.
	 * @return {string}
	 */
	get randomTag(): string {
		return '[RANDOM]';
	}

	/**
	 * @description Returns string literal "[DUR]". When passed as a query parameters in Freewheel ad calls, "[DUR]" gets replaced with the duration number by AVIA.
	 * @return {string}
	 */
	get durTag(): string {
		return '[DUR]';
	}

	/**
	 * @description Returns string literal "MIDROLL".
	 * @return {string}
	 */
	get midroll(): string {
		return 'MIDROLL';
	}

	/**
	 * @description Returns string literal "VARIABLE".
	 * @return {string}
	 */
	get variable(): string {
		return 'VARIABLE';
	}

	public static getInstance(): FreewheelConstants {
		return FreewheelConstants._instance;
	}
}